import React from 'react';
import { DriverReviewSample } from 'types/PropertyInsights';
import reviewsImg from 'assets/reviews.png';
import Button from 'components/Button/Button';
import Arrow from 'components/Icons/ArrowIcon';
import EmptyWidget from 'components/EmptyWidget/EmptyWidget';
import StarIcon from 'components/Icons/StarIcon';
import { MIN_SAMPLES_TO_SHOW_MODAL } from '../helpers';
import styles from './DriverReviewsWidget.module.css';

type SamplesProps = {
    samples: DriverReviewSample[];
    openModal: () => void;
};

function Samples({ samples, openModal }: SamplesProps): JSX.Element {
    const first3Samples = samples.slice(0, 3);
    return (
        <div className={styles.samplesContainer}>
            {samples.length < 2 ? (
                <EmptyWidget imgUrl={reviewsImg} title="No comments yet" message="Review comments will appear here" />
            ) : (
                <>
                    <div className={styles.samplesHeader}>
                        <h4>What They Say</h4>
                        {samples.length > MIN_SAMPLES_TO_SHOW_MODAL && (
                            <Button color="secondary" size="sm" onClick={openModal}>
                                View All <Arrow direction="right" />
                            </Button>
                        )}
                    </div>
                    {first3Samples.map((sample) => (
                        <SampleCommentAndRating key={sample.sk} sample={sample} />
                    ))}
                </>
            )}
        </div>
    );
}

export default Samples;

export function SampleCommentAndRating({ sample }: { sample: DriverReviewSample }): JSX.Element {
    return (
        <div key={sample.sk}>
            <p dangerouslySetInnerHTML={{ __html: `"${sample.comment}"` }} className={styles.samplesComment} />
            <div className={styles.samplesRating}>
                {Array.from(Array(5).keys()).map((num) => (
                    <StarIcon color={num >= sample.rating ? '#DAD9D6' : '#FF6712'} key={num} />
                ))}
            </div>
        </div>
    );
}
